export default __webpack_public_path__ + "static/media/manage-rules.ff2a691d.png";